export default {
  xeroAudit: undefined,
  xeroAudits: [],
};
